module.exports = __webpack_public_path__ + "media/Icons/btn_PDF-e3915d5e.svg";